var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectWrapper',{attrs:{"label":_vm.label,"value":_vm.value,"disabled":_vm.disabled,"options":_vm.options},on:{"update:value":function($event){return _vm.$emit('update:value', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }